module.exports = __webpack_public_path__ + "media/images/icons/autoassegnazione_allenamento-93754df6bd97699d8489bbd6bc301d31.svg";